// src/components/CategorySection.jsx
import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import { getAllCategory } from "../API/CategoryAPI";
import { Link } from "react-router-dom";


const CategorySection = () => {
    const [Category, setCategory] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res = await getAllCategory();
                setCategory(res);
            } catch (error) {
                console.error("Error fetching categories:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);

    const CategoryLoader = () => (
        <div className="flex flex-col items-center bg-[#f9f9f9] rounded-lg md:p-4 p-3 shadow animate-pulse">
            <div className="w-full md:h-32 h-24 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded-md"></div>
            <div className="mt-2 h-4 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded w-16"></div>
        </div>
    );


    return (
        <div className="px-3 md:px-0">
            <div className="container mx-auto px-4 bg-white md:py-6 rounded-xl md:-mt-16 -mt-14 pt-3 relative z-10">
                <div className=" ">
                    {loading ? (
                        <div className="grid grid-cols-2 md:grid-cols-7 gap-5">
                            {[...Array(7)].map((_, index) => (
                                <CategoryLoader key={index} />
                            ))}
                        </div>
                    ) : (
                        <Swiper
                            modules={[Autoplay]}
                            loop={true}
                            autoplay={{
                                delay: 2000,
                                disableOnInteraction: false,
                            }}
                            spaceBetween={20}
                            breakpoints={{
                                120: { slidesPerView: 2 },
                                320: { slidesPerView: 2.5 },
                                640: { slidesPerView: 3 },
                                768: { slidesPerView: 4 },
                                1024: { slidesPerView: 7 },
                            }}
                        >
                            {Category?.map((cat, index) => (
                                <SwiperSlide key={index}>
                                    <Link to={`/category/${cat.Id}`}>
                                        <div className="flex flex-col items-center bg-[#f9f9f9] rounded-lg md:p-4 p-3 shadow hover:shadow-lg transition border border-transparent transition-all duration-400 ease-in-out
                               hover:-translate-y-1
                               hover:bg-[#e1b37d14]
                               hover:border-[#e1b37d4d]">
                                            <img src={cat.Image} alt={cat.Name} className="w-full md:h-32 h-24 object-contain" />
                                            <span className="mt-2 font-medium text-gray-700">{cat.Name}</span>
                                        </div>
                                    </Link>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CategorySection;
